import { SVGProps } from 'react'

export const Explore = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM12 2C6.47716 2 2 6.47716 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM15.7354 9.14709L15.9561 8.04393L14.8529 8.26456L9.85291 9.26456L9.36262 9.36262L9.26456 9.85291L8.26456 14.8529L8.04393 15.9561L9.14709 15.7354L14.1471 14.7354L14.6374 14.6374L14.7354 14.1471L15.7354 9.14709ZM9.95607 14.0439L10.6374 10.6374L14.0439 9.95607L13.3626 13.3626L9.95607 14.0439Z"
      fill="currentColor"
    />
  </svg>
)
